module.exports = __webpack_public_path__ + "img/animation_jp.8104618.jpg";